import { POLYLINE_STYLES } from '@/components/common/Map/constants';
import { COLORS } from 'theme';

/**
 * Returns polyline options compatible with Google Maps API.
 * Works with both DirectionsRenderer.polylineOptions and custom <Polyline> components.
 *
 * @param {Object} options - Polyline configuration options.
 * @param {string} [options.lineStyle=POLYLINE_STYLES.SOLID] - One of SOLID, DASHED, or DOTTED.
 * @param {string} [options.strokeColor=COLORS.kinetikBlue] - Stroke color.
 * @param {string} [options.mode='TRANSIT'] - Trip mode.
 * @returns {Object} Polyline options for Google Maps.
 */
const getPolylineOptions = ({
  lineStyle = POLYLINE_STYLES.SOLID,
  strokeColor = COLORS.kinetikBlue,
  mode = 'TRANSIT',
}) => {
  if (lineStyle === 'solid') {
    return {
      visible: true,
      strokeColor,
      strokeOpacity: 0.8,
      strokeWeight: mode === 'TRANSIT' ? 4 : 3,
    };
  }

  const base = {
    visible: true,
    strokeOpacity: 0,
    strokeColor,
  };

  if (lineStyle === 'dotted') {
    return {
      ...base,
      icons: [
        {
          icon: {
            path: window.google.maps.SymbolPath.CIRCLE,
            fillOpacity: 1,
            strokeOpacity: 1,
            scale: 2,
          },
          offset: '0',
          repeat: '12px',
        },
      ],
    };
  }

  if (lineStyle === 'dashed') {
    return {
      ...base,
      icons: [
        {
          icon: {
            path: 'M 0 -1 L 0 1',
            strokeOpacity: 1,
            scale: 3,
          },
          offset: '0',
          repeat: '12px',
        },
      ],
    };
  }

  return {
    visible: true,
    strokeOpacity: 1,
  };
};

export default getPolylineOptions;
